export default __webpack_public_path__ + "static/media/agreement.402786ea.txt";